<template>
    <q-layout view="lhr lpr lfr">
        <q-header elevated>
            <gfk-header :title="siteTitle" :subtitle="siteSubtitle">
                <template #right-top>
                    <router-link :to="{name:'caseidStart'}">Home</router-link> |
                    Logged in as <strong>{{ userDisplayName }}</strong> |
                    <router-link :to="{name: 'logout'}">Log out</router-link>
                </template>
                <template #customer-logo>
                    <div  class="customer-logo" style="width:25em; font-family:monospace; color:#fff !important" >
                        <q-input label-color="white" filled inverted readonly v-model="activeCaseId" @click="$event.target.select()" label="Case Id" class="gfk-bg-primary gfk-q-input" ></q-input>
                    </div>
                </template>
            </gfk-header>
        </q-header>
        <q-page-container>
            <q-page>
                <div class="row xs-gutter">
                    <div class="col-lg-12" style="width: 100%;">
                        <q-card class="bg-white no-margin">
                            <q-card-section>
                                <div class="row items-center sm-gutter">
                                    <div class="no-wrap col">
                                    <h5>Select the records</h5>
                                        <div class="IDsearchCriteria" style="margin-bottom: 10px">
                                            <strong>Search criteria:</strong> <criteria-list :criteria="criteria"/>
                                        </div>
                                        <q-banner icon="info" class="bg-primary text-white q-alert shadow-2 bg-blue text-white gfk-banner">
                                            <template v-slot:avatar>
                                                <q-icon name="info" color="white" size="1.5rem" />
                                            </template>
                                            Please select the records that match the person you are looking for.
                                        </q-banner>
                                        <q-banner color="red" icon="error" class="bg-red text-white q-alert shadow-2 text-white">
                                            Not all locations could be searched.
                                            Failed locations: {{errorStatus.errorCount}} / {{errorStatus.totalLocations}}. {{errorStatus.errorMsg}}
                                        </q-banner>
                                        <div class="row justify-end">
                                            <q-btn color="blue-10" class="IDsearchAllSystems col-3 q-mt-md q-mb-md" label="Download All" @click="downloadAll" />
                                        </div>
                                        <q-table selection="multiple" v-model:selected="selected" class="IDdataTable overflow-auto" row-key="id" :rows="results" :columns="columns" >
                                            <q-tr :props="props"> 
                                                <q-th auto-width>
                                                    <q-checkbox
                                                        v-if="props.multipleSelect" 
                                                        v-model="props.selected" 
                                                            indeterminate-value="some"
                                                    /><span style="font-size:10px">Select all</span>
                                                </q-th>
                                                <q-th v-for="col in props.cols" :key="col.name" :props="props">
                                                    <div class="text-right">{{ col.label }}</div>
                                                </q-th>
                                            </q-tr>
                                            <template  v-slot:top-selection>
                                                <div class="col"></div>
                                                <q-btn class="IDselect" color="primary" flat @click="commitToSelection(selected)"><q-icon name="mode_edit" size="20px"/>Edit</q-btn>
                                                <a :href="generateDownload(selected)" :download="`details-selected-${activeCaseId}.json`">Download selected</a>
                                            </template>
                                            <template v-slot:body-cell-details="cell">
                                                <q-td :props="cell">
                                                    <q-btn round small class="IDbuttonMoreDetails items-center gfk-bg-primary text-white"  @click='log(cell.row)'><q-icon name="more_horiz"/></q-btn>
                                                    <a class="q-ma-sm" :href="generateRowDownload(cell.row)" :download="`details-${cell.row.id}-${activeCaseId}.json`"> <q-icon size="35pt" name="cloud_download"/> </a>
                                                </q-td>
                                            </template>
                                        </q-table>
                                    </div>
                                </div>
                            </q-card-section>
                        </q-card>
                    </div>
                </div>
            </q-page>
        </q-page-container>
        <q-footer>
            <gfk-footer/>
        </q-footer>
        <template>
            <div class="q-pa-md q-gutter">
                <q-dialog v-model="details" :content-css="{minHeight: '70vh', minWidth: '70vw'}">
                    <q-card>
                        <q-card-section class="gfk-bg-primary text-white dialog-header-footer">
                            <q-toolbar>
                                <q-toolbar-title>Details</q-toolbar-title>
                            </q-toolbar>
                        </q-card-section>
                        <div style="padding:10px">
                                <q-table :columns="detailsColumns" :rows="detailsData" dense />
                        </div>
                        <q-card-section elevated class="gfk-bg-primary text-white dialog-header-footer">
                            <q-toolbar slot="footer">
                                <div class="row inline full-width justify-between">
                                    <q-btn flat class="full-width" @click="details=false">Close</q-btn>
                                </div>
                            </q-toolbar>
                        </q-card-section>
                    </q-card>
                </q-dialog>
            </div>
        </template>
    </q-layout>
</template>

<script>
	import {
        QLayout, QToolbar, QSelect, QInnerLoading, QSpinnerGears, QCard, QBanner, QCardSection, QBtn, QDialog, QIcon, QInput, QHeader, QPageContainer, QFooter, QTd, QCheckbox, QTr, QTh, QPage, QToolbarTitle
    } from 'quasar';
	import store from '../store';
	import authenticateApi from '../api/auth';
	import datasourcesApi from '../api/datasources';

	import {
        SEARCH_CRITERIA,
        SEARCH_RESULTS_COLUMNS,
        SEARCH_RESULTS_TABLE,
        CASEID,
        CURRENT_SEARCH_ERROR_STATUS
	} from '../store/keys';
	
	import gfkHeader from './gfk-header.vue';
	import gfkFooter from './gfk-footer.vue';
	import siteData from '../mixins/site-data-mixin';
	import CriteriaList from './criteria-list.vue';
    import searchSelectionStore from '../store/searchSelection';

	export default {
		mixins: [siteData],
		components: {
            CriteriaList,
			QLayout,
			QToolbar,
			gfkHeader,
			gfkFooter,
			QSelect,
			QInnerLoading,
			QSpinnerGears,
            QCard,
            QCardSection,
            QBtn,
            QDialog,
            QIcon,
            QBanner,
            QInput,
            QHeader,
            QPageContainer,
            QFooter,
            QTd,
            QTr,
            QTh,
            QCheckbox,
            QPage,
            QToolbarTitle
		},
		props: {
		},
        methods: {
             downloadAll() {
                const searchResults = store.getters[SEARCH_RESULTS_TABLE];
                console.log(searchResults[0]);
                const downloadData = _.map(searchResults, (s) => ({
                    location: s.location,
                    data: s.rowData
                }));
                const dataStr = `data:text/json;charset=utf-8,${encodeURIComponent(JSON.stringify(downloadData))}`;
                const downloadAnchorNode = document.createElement('a');
                downloadAnchorNode.setAttribute('href', dataStr);
                downloadAnchorNode.setAttribute('download', `all-search-results-${this.activeCaseId}.json`);
                document.body.appendChild(downloadAnchorNode);
                downloadAnchorNode.click();
                downloadAnchorNode.remove();
            },
            generateDownload(selection) {
                // console.log(selection);
                if (selection.length > 0) {
                    return `data:text/json;charset=utf-8,${encodeURIComponent(JSON.stringify(_.map(selection, (s) => ({
                        location: s.location,
                        data: s.rowData
                    }))))}`;
                }
                return '#';
            },
            generateRowDownload(row) {
                const locatedRow = {
                    location: row.location,
                    data: row.rowData
                };
                return `data:text/json;charset=utf-8,${encodeURIComponent(JSON.stringify(locatedRow))}`;
            },
            commitToSelection(selected) {
                const recordIds = _.map(selected, 'id');
		        datasourcesApi.get().then((datasources) => {
                    /** test data **/
                    //datasources = {"atlas_core":{"displayName":"ATLAS","appID":"4702"},"atlas_smt":{"displayName":"ATLAS","appID":"4702"},"confirmit":{"displayName":"Confirmit","appID":"4827"},"confirmit_cati":{"displayName":"Confirmit","appID":"4827"},"confirmit_sys":{"displayName":"Confirmit","appID":"4827"},"dimensions":{"displayName":"Dimensions","appID":"4895"}};
                    searchSelectionStore.recordIds=recordIds;
                    searchSelectionStore.datasources=datasources;
                    this.$router.push({
                        name: 'recordModification'
                    });
		        })
            },
            log(props) {
                this.detailsData = _.sortBy(
                    _.map(Object.keys(props.rowData), (key) => (
                        {
                            variable: key,
                            value: props.rowData[key]
                        }
                    )),
                    'variable'
                );
                this.details = true;
                console.log(props);
            }
        },
		data() {
			return {
                details: false,
                selected: [],
                detailsData: [],
                detailsColumns: [
                    {
                        label: 'Variable',
                        field: 'variable'
                    },
                    {
                        label: 'Value',
                        field: 'value'
                    }
                ]// ,
                // config: {
                //     rowHeight: '65px',
                //     pagination: {
                //         rowsPerPage: 5,
                //         options: [5, 10, 15, 30, 50, 500]
                //     },
                //     selection: 'multiple',
                //     rightStickyColumns: 1
                // }
			};
		},
		computed: {
			userDisplayName() {
                return authenticateApi.getUsername();
			},
            activeCaseId() {
                return store.getters[CASEID];
            },
            criteria() {
                return store.getters[SEARCH_CRITERIA];
            },
            results() {
                return store.getters[SEARCH_RESULTS_TABLE];
            },
            columns() {
                return store.getters[SEARCH_RESULTS_COLUMNS];
            },
            errorStatus() {
                return store.getters[CURRENT_SEARCH_ERROR_STATUS];
            }
		}
	};
</script>
